import React from 'react'

/**
 * recursively gets the length of all text under a React.ReactNode
 *
 * @param node a React.ReactNode
 */
export function getReactNodeLength(node: React.ReactNode): number {
  if (typeof node === 'string') return node.length
  else if (typeof node === 'number' || typeof node === 'boolean')
    return `${node}`.length
  else if (Array.isArray(node))
    return [...node].reduce<number>(
      (length, child) => length + getReactNodeLength(child),
      0
    )
  else if (React.isValidElement(node))
    return getReactNodeLength(node.props.children)
  else return 0
}

/**
 * recursively gets all the text under a React.ReactNode
 *
 * @param node a React.ReactNode
 */
export function getDeepestString(node: React.ReactNode): string {
  if (typeof node === 'string') return node
  else if (typeof node === 'number' || typeof node === 'boolean')
    return `${node}`
  else if (Array.isArray(node))
    return node.map(getDeepestString).join(' ').trim()
  else if (React.isValidElement(node))
    return getDeepestString(node.props.children)
  else return ''
}
